module.exports = require("./ar.d.ts");